import angular from 'angular';
import _ from 'lodash';
import crypto from 'crypto-js';

const LaboxSSAPI = angular.module('labox.sse.api', ['storage'])
  .service('laboxSSapi', ['$http', '$q','storage', function ($http, $q,storage) {

    this.config = {
      dev:{
        "cassservice":"http://dev.casservices.cv.net/optimum-support/services/v1/",
        "bpKeySecretID": "gsB74usx8n",
        "bpKeySecret": "663C1D571ED5DD6858D8DFBA89CC2"
      },
      stage:{
        "cassservice":"http://stage2.casservices.cv.net/optimum-support2/services/v1/",
        "bpKeySecretID": "gsB74usx8n",
        "bpKeySecret": "663C1D571ED5DD6858D8DFBA89CC2"
      },
      prod:{
        "cassservice":"http://casservices.cv.net/optimum-support/services/v1/",
        "bpKeySecretID": "ho4w482t7U",
        "bpKeySecret": "5D34622EAA5D931EB3BB6B4A918A8"
      }
      //stage:{
      //"cassservice":"http://stage2.casservices.cv.net/optimum-support2/services/v1/",
      //"bpKeySecretID": "gsB74usx8n",
      //"bpKeySecret": "663C1D571ED5DD6858D8DFBA89CC2"
      //}
    };

    const GET = 'get';
    const POST = 'post';

    this.wrap = (url, config, resultName,method,data) => {

      const handleWaiters = resultName => {
        if (this[resultName + 'Waiters']) {
          this[resultName + 'Waiters'].forEach(waiterCallback => {
            this[resultName + 'Promise'].then(waiterCallback.bind(undefined, undefined));
            this[resultName + 'Promise'].catch(waiterCallback.bind(undefined));
          });
        }
      };

      // console.log('## DATA ## API REQUEST ' + resultName);

      let promise;

      if (method.toLowerCase() === GET) {
        promise = $http.get(url,config);
      } else if (method.toLowerCase() === POST) {
        promise = $http.post(url, data,config);
      }

      promise.then(result => {
        // console.log('## DATA ## API RESULT ' + resultName, url, result);
        if (resultName) {
          this[resultName + 'Result'] = result;
        }
      });

      promise.catch(error => {
        console.error('## DATA ## API ERROR ' + resultName, url, error);
        if (resultName) {
          this[resultName + 'Error'] = error;
        }
      });

      this[resultName + 'Promise'] = promise;

      handleWaiters(resultName);

      return promise;
    };

    this.waitFor = (name, callback) => {
      if (this[name + 'Result']) {
        callback(undefined, this[name + 'Result']);
      } else if (this[name + 'Error']) {
        callback(this[name + 'Error']);
      } else if (this[name + 'Promise']) {
        this[name + 'Promise'].then(callback.bind(undefined, undefined));
      } else {
        this[name + 'Waiters'] = this[name + 'Waiters'] || [];
        this[name + 'Waiters'].push(callback);
      }
    };


    //------------------Direct API CALLS------------------------------------------//

    this.getAllOptimumIds = () => {
      var cidx = storage.getItem('session','home_id');
      return this.wrap('/api/getalloptimumids/cidx=' + cidx, {}, 'getAllOptimumIds','GET');
    };

    this.getAllSuddenlinkIds = () => {
      var cidx = storage.getItem('session','home_id');
      return this.wrap('/api/getallsdlids/cidx=' + cidx, {}, 'getAllSuddenlinkIds','GET');
    };

    this.accountInfo = () => {
      var cidx = storage.getItem('session','home_id');
      return this.wrap('/api/opt/acctinfo/cidx='+cidx,{}, 'accountInfoProfile','GET');
    };

    this.getOptVideoTutorials = () => {
      return this.wrap('/api/tutorial/opt', {}, 'getVideoTutorials','GET');
    };

    this.getSdlVideoTutorials = () => {
      return this.wrap('/api/tutorial/sdl', {}, 'getVideoTutorials','GET');
    };



    this.getVideoBill = () => {
      var cidx = storage.getItem('session','accno');
      return this.wrap('/api/videobill/accountnumber='+cidx, {}, 'getVideoBill','GET');
    };

    this.getOptFaq = () => {
      return this.wrap('api/quicktips/opt', {}, 'getOptFaq','GET');
    };

    this.getSdlFaq = () => {
      return this.wrap('api/quicktips/sdl', {}, 'getSdlFaq','GET');
    };

    this.logData = (dataval) => {
     // var dataval = storage.getItem('session','home_id');
      return this.wrap('api/logs/data='+dataval,{}, 'logData','GET');
    }
  }]);

export default LaboxSSAPI;



// WEBPACK FOOTER //
// ./client/app/api/api.js